// extracted by mini-css-extract-plugin
export var quillEditor = "_ii-1";
export var variable = "_ii-0";